import type { ApiClient } from "@/lib/api";
import type { McpServerPatchRequest, McpServerUpdateRequest } from "../types";

export const updateMcpGateway = async (options: {
  client: ApiClient;
  id: string;
  payload: McpServerUpdateRequest;
}) => {
  const { client, id, payload } = options;
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  const body = { id, ...payload } as Record<string, unknown>;
  const { data } = await client.put(`/gateways/${id}`, body);
  return data;
};

export const patchMcpGateway = async (options: {
  client: ApiClient;
  id: string;
  payload: McpServerPatchRequest;
}) => {
  const { client, id, payload } = options;
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  const body = { id, ...payload } as Record<string, unknown>;
  const { data } = await client.patch(`/gateways/${id}`, body);
  return data;
};
